import "./App.css";
import { useDispatch, useSelector } from "react-redux";
import {
  authTokenLoaderSelector,
  errorMessageSelector,
  getOAuthToken,
  resourceLoaderSelector,
  showErrorSelector,
  toggleShowError,
  updateIsMobile,
} from "./store/config/configurationSlice";
import { Fragment, lazy, Suspense, useEffect } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import Loader from "./components/common/Loader";
import store from "./store";
import CustomModal from "./components/common/CustomModal";
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
const Routers = lazy(() => import("./Routers"));
function App() {
  const authTokenLoader = useSelector(authTokenLoaderSelector);
  const resourceLoader = useSelector(resourceLoaderSelector);
  const showError = useSelector(showErrorSelector);
  const errorMsg = useSelector(errorMessageSelector);
  const changes = useMediaQuery("(min-width:801px)");
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getOAuthToken());
  }, [dispatch]);
  useEffect(() => {
    dispatch(updateIsMobile(!changes));
    // eslint-disable-next-line
  }, [changes]);
  const close = () => {
    dispatch(toggleShowError(false));
    window.open(store.getState()?.config?.envConfig?.homePage, "_self");
  };
  return (
    <Fragment>
      <Header />
      <Suspense fallback={<Loader />}>
        {authTokenLoader || resourceLoader ? <Loader /> : <Routers />}
      </Suspense>
      <Footer />
      <CustomModal
        heading={"Error"}
        description={errorMsg}
        close={close}
        isOpen={showError}
        buttonText={"OK"}
      />
    </Fragment>
  );
}

export default App;
